<template>
  <div class="apple-ui-artwork" :class="{ 'is-round': round, 'is-loading': loading }" :style="artworkStyle" :aria-busy="String(loading)">
    <ArtworkImage :src="src" :fallback="fallback" :retry-key="retryKey" :alt="alt" @source-error="$emit('source-error', $event)" />
    <span v-if="loading" class="apple-ui-artwork-loading" role="status">正在加载</span>
    <slot />
  </div>
</template>

<script>
import ArtworkImage from '../../components/ArtworkImage.vue';

export default {
  name: 'AppleArtwork',
  components: { ArtworkImage },
  props: {
    src: { type: String, default: '' },
    fallback: { type: String, required: true },
    retryKey: { type: [String, Number], default: '' },
    alt: { type: String, default: '' },
    size: { type: [String, Number], default: 64 },
    round: Boolean,
    loading: Boolean,
  },
  computed: {
    artworkStyle() {
      const size = typeof this.size === 'number' ? `${this.size}px` : this.size;
      return { '--apple-artwork-size': size, '--apple-artwork-height': size.endsWith('%') ? 'auto' : size };
    },
  },
};
</script>

<style scoped>
.apple-ui-artwork { position:relative; display:block; flex:none; width:var(--apple-artwork-size); height:var(--apple-artwork-height); aspect-ratio:1; min-width:0; overflow:hidden; border-radius:var(--apple-ui-radius-artwork,8px); background:var(--apple-ui-surface,var(--color-secondary-bg)); }
.apple-ui-artwork.is-round { border-radius:50%; }
.apple-ui-artwork ::v-deep img { display:block; width:100%; height:100%; object-fit:cover; border-radius:inherit; }
.apple-ui-artwork-loading { position:absolute; inset:auto 0 0; padding:3px 5px; background:color-mix(in srgb,var(--color-body-bg) 84%,transparent); color:var(--apple-ui-muted,var(--color-secondary)); font-size:10px; line-height:1.2; text-align:center; }
.apple-ui-artwork.is-loading ::v-deep img { opacity:.58; }
</style>
